import i18n from '@/plugins/i18n'
import { HEALTHY_HABITS_LAYOUT } from '@/constants/layouts'

function scrollTop(to, from, next) {
    window.scrollTo(0, 0)
    next()
  }

export default [
    {
        name: 'healthyHabits',
        path: '/',
        component: () => import('@/components/views/healthy-habits/HealthyHabits'),
        meta: {
            layout: HEALTHY_HABITS_LAYOUT,
            title: {
                text () {
                    return i18n.t('healthyHabitsTitle')
                }
            },
            i18n: 'public/views/healthy-habits'
        },
        beforeEnter: scrollTop
    },
    {
        name: 'healthyHabitsFaqs',
        path: 'healthyHabitsFaqs',   
        component: () => import('@/components/views/healthy-habits/HealthyHabitsFaqs'),
        meta: {
            layout: HEALTHY_HABITS_LAYOUT, 
            title: {
                text () {
                    return i18n.t('faqs-title')
                }
            },     
            i18n: 'public/views/healthy-habits'
        },
        beforeEnter: scrollTop
    },
    {
        name: 'healthyHabitsCreate',
        path: 'create/:historyVarName/:healthyHabitName/:healthyHabitFrequencyId/:healthyHabitMeasureUnit/:historyPatientId?',
        component: () => import('@/components/views/healthy-habits/HealthyHabits'),
        meta: {
            layout: HEALTHY_HABITS_LAYOUT, 
            title: {
                text () {
                    return i18n.t('healthyHabitsTitle')
                }
            },     
            i18n: 'public/views/healthy-habits'
        },
        beforeEnter: scrollTop
    },
    {
        name: 'healthyHabitsCreateByType',
        path: 'createByType/:historyGroupId/:healthyHabitName/:healthyHabitFrequencyId/:healthyHabitMeasureUnit/:historyPatientId?',
        component: () => import('@/components/views/healthy-habits/HealthyHabits'),
        meta: {
            layout: HEALTHY_HABITS_LAYOUT, 
            title: {
                text () {
                    return i18n.t('healthyHabitsTitle')
                }
            },     
            i18n: 'public/views/healthy-habits'
        },
        beforeEnter: scrollTop
    },
    {
        name: 'healthyHabitsShow',
        path: 'show/:healthyHabitPreselectedId/:historyPatientId?',
        component: () => import('@/components/views/healthy-habits/HealthyHabits'),
        meta: {
            layout: HEALTHY_HABITS_LAYOUT, 
            title: {
                text () {
                    return i18n.t('healthyHabitsTitle')
                }
            },     
            i18n: 'public/views/healthy-habits'
        },
        beforeEnter: scrollTop
    },
    {
        name: 'healthyHabitsStatistics',
        path: ':id',
        component: () => import('@/components/views/healthy-habits/HealthyHabitsStatistics'),
        meta: {
            layout: HEALTHY_HABITS_LAYOUT,
            title: {
                text () {
                    return i18n.t('healthyHabitsTitle')
                }
            },
            i18n: 'public/views/healthy-habits'
        },
        beforeEnter: scrollTop
    }
  ]


// WEBPACK FOOTER //
// ./src/router/routes/webapp/healthyhabits.routes.js